import { deliveryService } from '../../helpers/services/delivery.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const DELIVERY_MODULE = 'delivery'

export const GET_ALL_DELIVERIES = 'getAllDeliveries'
export const GET_DELIVERY = 'getDelivery'
export const CREATE_DELIVERY = 'createDelivery'
export const UPDATE_DELIVERY = 'updateDelivery'
export const UPDATE_DELIVERY_STATUS = 'updateDeliveryStatus'
export const CREATE_DELIVERY_RETURN = 'createDeliveryReturn'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'

function mapRow(item) {
  return {
    id: item.uuid,
    type: item.type,
    parentUuid: item.parent_uuid,
    autocountDocNo: item.autocount_doc_no,
    salesDocNo: item.sales_doc_no,
    siDocNo: item.si_doc_no,
    docType: item.doc_type,
    debtorCode: item.debtor_code,
    driverUuid: item.driver_uuid,
    driverName: item.driver?.name,
    status: item.status,
    dispatchAt: filtersHelper.getDateFormat(item.dispatch_at),
    deliveredAt: filtersHelper.getDateFormat(item.delivered_at),
    recipientName: item.recipient_name,
    deliveryAddress: item.delivery_address,
    notes: item.notes,
    isActive: item.is_active,
    createdAt: filtersHelper.getDateFormat(item.created_at),
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_DELIVERIES]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    deliveryService.getAllDeliveries(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_DELIVERY]({ commit }, { id }) {
    commit(REQUESTING, 'detail')
    return deliveryService.getDelivery(id).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_DELIVERY]({ commit, dispatch }, { data, filter }) {
    commit(REQUESTING, 'save')
    return deliveryService.createDelivery(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.delivery')]))
      commit(SUCCESS); if (filter) dispatch(GET_ALL_DELIVERIES, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPDATE_DELIVERY]({ commit, dispatch }, { id, data, filter }) {
    commit(REQUESTING, 'save')
    return deliveryService.updateDelivery(id, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.delivery')]))
      commit(SUCCESS); if (filter) dispatch(GET_ALL_DELIVERIES, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPDATE_DELIVERY_STATUS]({ commit, dispatch }, { id, status, extra, filter }) {
    commit(REQUESTING, 'save')
    return deliveryService.updateDeliveryStatus(id, status, extra).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('label.status')]))
      commit(SUCCESS); if (filter) dispatch(GET_ALL_DELIVERIES, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_DELIVERY_RETURN]({ commit, dispatch }, { id, data, filter }) {
    commit(REQUESTING, 'save')
    return deliveryService.createDeliveryReturn(id, data).then((r) => {
      sharedHelper.alertSuccessMessage('Delivery return created')
      commit(SUCCESS); if (filter) dispatch(GET_ALL_DELIVERIES, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data.data ? mapRow(data.data) : {}
  },
  [FAILURE](state) { state.status = { list: true, detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
